import { Img } from '../../../Common/Img';

interface Props {
    description: string;
}

export const NoDataImage = ({ description }: Props) => {
    return (
        <div className="project-overview-dashboard__no-data-image">
            <Img src="/svg/no-projects.svg" alt="No projects" />
            <h5 className="project-overview-dashboard__no-data-image-description">{description}</h5>
        </div>
    );
};
